<template>
  <table>
    <tr v-for="(email, id) in emails" :key="id">
      <td>
        {{ email.toEmail }}
      </td>
      <td>
        {{ email.subject }}
      </td>
      <td>
        {{ email.sentAt }}
      </td>
      <td>
        <a v-if="email.testMessageUrl" :href="email.testMessageUrl">View Email</a>
        <span v-else>No Email</span>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'EmailList',
  props: {
    emails: {
      type: Array,
      required: true
    }
  }
};
</script>
